import "bootstrap/dist/css/bootstrap.min.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AddressManager from './AddressManager.js';

const AddressPage = () => {
  const user = useSelector(s => s.auth.user);
  const navigate = useNavigate();

  if (!user) {
    return (
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-6 text-center">
            <div className="card border-0 shadow-sm rounded-4 p-5">
              <i className="bi bi-lock display-4 text-muted mb-3"></i>
              <h3 className="fw-bold mb-3">Sign In Required</h3>
              <p className="text-muted mb-4">Please sign in to manage your delivery addresses</p>
              <button
                className="btn btn-dark rounded-pill px-4 py-3"
                style={{ background: "#2f0f0c" }}
                onClick={() => navigate("/signin")}
              >
                <i className="bi bi-person-circle me-2"></i>
                Sign In to Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-5">
      <style jsx>{`
        .page-header {
          background: linear-gradient(135deg, #2f0f0c, #4a1a15);
          border-radius: 20px;
          padding: 2rem;
          margin-bottom: 2rem;
          color: white;
        }
        .breadcrumb-item + .breadcrumb-item::before {
          content: "›";
          color: #6c757d;
        }
      `}</style>

      {/* Page Header */}
      <div className="page-header text-center">
        <nav aria-label="breadcrumb" className="mb-3">
          <ol className="breadcrumb justify-content-center mb-0">
            <li className="breadcrumb-item">
              <a href="/" className="text-white-50 text-decoration-none">Home</a>
            </li>
            <li className="breadcrumb-item active text-white" aria-current="page">
              My Addresses
            </li>
          </ol>
        </nav>
        <h1 className="fw-bold mb-2">
          <i className="bi bi-geo-alt me-3"></i>
          Manage Addresses
        </h1>
        <p className="mb-0 opacity-75">
          Add, edit, and manage your delivery addresses for faster checkout
        </p>
      </div>

      {/* Address Manager */}
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="card border-0 shadow-sm rounded-4 p-4">
            <AddressManager />
          </div>
        </div>
      </div>

      {/* Help Section */}
      <div className="row justify-content-center mt-5">
        <div className="col-lg-8">
          <div className="card border-0 bg-light rounded-4 p-4">
            <h5 className="fw-bold mb-3">
              <i className="bi bi-question-circle me-2 text-primary"></i>
              Need Help?
            </h5>
            <div className="row g-3">
              <div className="col-md-6">
                <div className="d-flex align-items-start">
                  <i className="bi bi-check-circle text-success me-2 mt-1"></i>
                  <div>
                    <strong>Multiple Addresses</strong>
                    <p className="small text-muted mb-0">Save multiple addresses for home, office, and other locations</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex align-items-start">
                  <i className="bi bi-lightning text-warning me-2 mt-1"></i>
                  <div>
                    <strong>Quick Checkout</strong>
                    <p className="small text-muted mb-0">Select saved addresses during checkout for faster ordering</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex align-items-start">
                  <i className="bi bi-pencil text-info me-2 mt-1"></i>
                  <div>
                    <strong>Easy Editing</strong>
                    <p className="small text-muted mb-0">Update or delete addresses anytime with simple controls</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex align-items-start">
                  <i className="bi bi-shield-check text-success me-2 mt-1"></i>
                  <div>
                    <strong>Secure Storage</strong>
                    <p className="small text-muted mb-0">Your address information is encrypted and securely stored</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddressPage;